import { Column } from "../../../../../components/table-simple/table.types";
import {
  IGetUpcomingRenewalData,
  ProximaRenovacion,
} from "../../../../../services/ClientsDashboardServices.dto";

export const formatRenewalTableData = (data: IGetUpcomingRenewalData | null) => {
  if (!data || !data.proximasRenovacionesPorSubramo || !(data.proximasRenovacionesPorSubramo.length > 0)) {
    return null;
  }

  const columns: Column[] = [
    {
      title: "",
      key: "primera",
      position: "left",
    },
  ];
  const tableData: { [key: string]: string | number }[] = [{ primera: "Pólizas Renovación " }];

  data.proximasRenovacionesPorSubramo.forEach((item: ProximaRenovacion) => {
    const { subramo, proximasRenovaciones } = item;
    columns.push({ title: subramo, key: subramo, position: "center" });
    tableData[0][subramo] = proximasRenovaciones;
  });

  return {
    columns,
    tableData,
  };
};
